import { render, staticRenderFns } from "./cardParticipantInfo.vue?vue&type=template&id=22091a7d&"
import script from "./cardParticipantInfo.vue?vue&type=script&lang=js&"
export * from "./cardParticipantInfo.vue?vue&type=script&lang=js&"
import style0 from "./cardParticipantInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports